import { BaseApiResponseModel } from "api/model/BaseApiResponseModel";
import { storageApiPaths } from "api/apiPaths";
import client from "api/client";
import { StoragesRequestModel } from "./model/StoragesRequestModel";
import { StoragesResponseModel } from "./model/StoragesResponseModel";
import { StorageCreateActionsRequestModel } from "./model/createActions/StorageCreateActionsRequestModel";
import { StorageDetailResponseModel } from "./model/detail/StorageDetailResponseModel";
import { StorageUpdateActionsRequestModel } from "./model/updateActions/StorageUpdateActionsRequestModel";

export interface IStoragesRepository {
  getList(
    params: StoragesRequestModel
  ): Promise<BaseApiResponseModel<StoragesResponseModel[]>>;
  getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<StorageDetailResponseModel>>;
  createStorage(
    body: StorageCreateActionsRequestModel
  ): Promise<BaseApiResponseModel<StorageDetailResponseModel>>;
  updateStorage(
    body: StorageUpdateActionsRequestModel
  ): Promise<BaseApiResponseModel<StorageDetailResponseModel>>;
  deleteStorage(params: {
    code: string;
  }): Promise<BaseApiResponseModel<StorageDetailResponseModel>>;
}

class StoragesImpl implements IStoragesRepository {
  async getList(
    params: StoragesRequestModel
  ): Promise<BaseApiResponseModel<StoragesResponseModel[]>> {
    return await client?.get(storageApiPaths?.LIST, params);
  }
  async getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<StorageDetailResponseModel>> {
    return await client?.get(storageApiPaths?.DETAIL, params);
  }
  async updateStorage(
    body: StorageUpdateActionsRequestModel
  ): Promise<BaseApiResponseModel<StorageDetailResponseModel>> {
    return await client?.put(storageApiPaths?.UPDATE, body);
  }
  async createStorage(
    body: StorageCreateActionsRequestModel
  ): Promise<BaseApiResponseModel<StorageDetailResponseModel>> {
    return await client?.post(storageApiPaths?.CREATE, body);
  }
  async deleteStorage(params: {
    code: string;
  }): Promise<BaseApiResponseModel<StorageDetailResponseModel>> {
    return await client?.delete(storageApiPaths?.DELETE, params);
  }
}

export const defaultStoragesRepository = new StoragesImpl();
